<div class="time-schedule-result">
  @if (!schedules().length) {
    <ui-no-data
      [imgSrc]="noData.imgSrc"
      [title]="noData.title | translate"
      [createButtonText]="noData.createButtonText | translate"
      (onCreate)="openCreatePanel()"
    ></ui-no-data>
  } @else {
    <div class="time-schedule-result__toolbar">
      <ui-search
        [placeholder]="'SCHEDULE_LIST.PLACEHOLDERS.SEARCH' | translate"
        [searchQuery]="searchQuery()"
        (onInput)="onSearchQuery($event)"
      ></ui-search>
      <ui-button
        type="primary"
        [text]="'SCHEDULE_LIST.BUTTONS.CREATE' | translate"
        (clickAction)="openCreatePanel()"
      ></ui-button>
    </div>

    @if (!filteredSchedules().length) {
      <ui-no-data [imgSrc]="noResults.imgSrc" [title]="noResults.title | translate"></ui-no-data>
    } @else {
      <div class="time-schedule-result__table">
        <ui-dataset-table
          [data]="filteredSchedules()"
          [config]="tableConfig()"
          (rowAction)="onRowAction($event)"
        ></ui-dataset-table>
      </div>
    }
  }
</div>
